import {
  FETCH_PAGE_CONTENT_BEGIN,
  FETCH_PAGE_CONTENT_FAILURE,
  FETCH_PAGE_CONTENT_SUCCESS,
  SET_BREADCRUMB_LIST_IN_REDUX
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";

export const fetchPageContent = url => async (dispatch, getState) => {
  dispatch({ type: FETCH_PAGE_CONTENT_BEGIN });
  try {
    const response = await API({
      method: "POST",
      url
    });
    if (response && response.data) {
      const pageData = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
      let payload = {};
      if (pageData.sections.length) {
        const checkObject = key => {
          if (pageData && pageData.sections && Array.isArray(pageData.sections)) {
            for (let item of pageData.sections) {
              if (item[key]) {
                return item[key];
              } else if (Array.isArray(item)) {
                for (let el of item) {
                  if (el[key]) {
                    return el[key];
                  }
                }
              }
            }
          }
          return {};
        };


        if (
          url !== ENDPOINTS.FETCH_WIRELINE_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_OTT_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_CVA_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_AUTHORIZED_AGENT_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_FAMILY_MONEY_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_VILS_LANDING_PAGE &&
          url !== ENDPOINTS.FETCH_FORMER_CUSTOMER_LANDING_NEW &&
          url !== ENDPOINTS.FETCH_GUEST_FLOW_LANDING_NEW &&
          url !== ENDPOINTS.FETCH_FORMER_REQUEST_HISTORY &&
          url !== ENDPOINTS.FETCH_GUEST_REQUEST_HISTORY
        ) {
          if (pageData.sections.length > 1) {
            if (checkNestedObject(pageData.sections[1], "navigation_items")) {
              payload = {
                ...pageData.sections[0],
                ...pageData.sections[1]
              };
            }
          } else {
            payload = {
              ...pageData.sections[0],
              gnavDropdown: { ...checkObject("gnavDropdown") }
            };
          }
        } else {
          if (url === ENDPOINTS.FETCH_AUTHORIZED_AGENT_LANDING_PAGE) {
            payload = {
              landing_page: pageData.sections[0],
              sc_pagetitle: pageData.sc_pagetitle,
              seo_description: pageData.seo_description,
              breadCrumbs: { ...checkObject("breadCrumbs") },
              gnavDropdown: { ...checkObject("gnavDropdown") },
              ...pageData.sections[1]
            };
          } else {
            payload = {
              ...pageData,
              breadCrumbs: { ...checkObject("breadCrumbs") },
              gnavDropdown: { ...checkObject("gnavDropdown") }
            };
          }
        }
        dispatch({
          type: FETCH_PAGE_CONTENT_SUCCESS,
          payload: {
            ...payload,
            fetchedPages: [...getState().pageContent.fetchedPages, url]
          }
        });
      } else {
        dispatch({ type: FETCH_PAGE_CONTENT_FAILURE });
      }
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: FETCH_PAGE_CONTENT_FAILURE });
  }
};

export const setBreadCrumbListInRedux = payload => dispatch => {
  dispatch({ type: SET_BREADCRUMB_LIST_IN_REDUX, payload });
};
